import CustomError from "components/form/CustomError";
import CustomField from "components/form/CustomField";
import { Form, Formik } from "formik";
import { handleSubmitForm } from "helpers/apiUtils";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { initiateRefund } from "store/slices/customersSlice";
import { refundInitiationValidationSchema } from "utils/validations";

function RefundInitiationForm({
  transactionId,
  amount,
  onSubmit,
  isLoading,
  addRefundedTransactionId,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const initialValues = {
    transactionId: transactionId || "",
    amount: amount || "",
    reason: "",
  };

  const handleSubmit = (values) => {
    handleSubmitForm({
      dispatch,
      action: initiateRefund,
      payload: values,
      onSuccess: () => {
        addRefundedTransactionId(transactionId);
        onSubmit();
      },
    });
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={refundInitiationValidationSchema(t)}
        onSubmit={handleSubmit}
      >
        {({ errors, touched }) => (
          <Form>
            <Row>
              <Col lg={12}>
                <div className="form_field">
                  <CustomField
                    label={t("Amount")}
                    name="amount"
                    placeholder={t("Enter amount")}
                    readOnly
                    disabled
                  />
                </div>
              </Col>

              <Col lg={12}>
                <div className="form_field">
                  <CustomField
                    label={t("Reason")}
                    as="textarea"
                    name="reason"
                    placeholder={t("Enter reason for refund")}
                    rows={4}
                  />
                </div>
              </Col>

              <Col lg={12} className="d-flex justify-content-end gap-2 mt-3">
                <button type="submit" className="main_btn" disabled={isLoading}>
                  {isLoading ? t("Processing...") : t("Submit")}
                </button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default RefundInitiationForm;
